<template>
  <div id="report" class="font14" style="display: flex;height: 100%;">
    <div style="width: 200px;padding: 20px;">
      <div>
        <div class="f_w " style="border-left: 4px solid #C73343;padding:0 10px;">{{$t('common.BrandType')}}</div>
        <allSelect class="m_l_10 m_t_10 m_b_20" @on-change="brandChange" :chooseData="brandList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.brandCode" :width="'173px'">
        </allSelect>
<!--        <label :key="index" v-for="(item, index) in brandList">-->
<!--          <input class="radio_type" type="radio" name="brandRadio" :value="item.Code" v-model="postData.brandCode" @change="brandChange(item)" />{{item.Name}}-->
<!--        </label>-->
      </div>
      <div class="m_b_20">
        <div class="f_w" style="border-left: 4px solid #C73343;padding:0 10px;">{{$t('common.FilterBy')}}</div>
        <label class="f_w m_t_10 p_t_b_5" :style="sopOrShipment==1?'color:#bbb;':''">
          <input class="radio_type" type="radio" name="chartRadio" :disabled="sopOrShipment==1" :value="3" v-model="postData.quartersOrMonths" @change="filterChange" />{{$t('common.ByYear')}}
        </label>
        <label class="f_w p_t_b_5">
          <input class="radio_type" type="radio" name="chartRadio" :value="1" v-model="postData.quartersOrMonths" @change="filterChange" />{{$t('common.ByQuarter')}}
        </label>
        <div style="display: flex;align-items: center">
          <label class="f_w p_t_b_5">
            <input class="radio_type" type="radio" name="chartRadio" :value="2" v-model="postData.quartersOrMonths" @change="filterChange" />{{$t('common.ByMonth')}} &nbsp;&nbsp;
          </label>
          <allSelect v-if="postData.quartersOrMonths==2" @on-change="yearChange" :chooseData="yearList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.year" :width="'100px'">
          </allSelect>
        </div>
      </div>
      <div>
        <div class="f_w" style="border-left: 4px solid #C73343;padding:0 10px;">{{$t('common.AnnualTotal')}}</div>
        <table v-if="postData.quartersOrMonths!=3" class="chartTable font12 m_l_10">
          <tr>
            <td style="position: relative" class="f_w" @click="showInfo('YTD')" :style="postData.year==year?'':'color:#959595'">YTD <i class="icon iconfont icon-info"></i>
              <div v-if="SalesDataMonth==12" v-show="showInfoFlag=='YTD'&&SalesDataMonth==month" class="info-block">{{$t('common.YTDInfo', {'year': SalesDataYear, 'month': $t('common.'+SalesDataMonth+'M')})}}</div>
              <div v-else v-show="showInfoFlag=='YTD'" class="info-block">{{$t('common.YTDInfo', {'year': SalesDataYear, 'month': $t('common.'+SalesDataMonth+'M')})}}</div>
            </td>
            <td class="f_w" :style="postData.year==year?'':'color:#959595'">{{$commonJs.numFixed(ytdTableData.YTD)}}</td>
          </tr>
          <tr>
            <td style="position: relative" class="f_w" @click="showInfo('YTG')" :style="postData.year==year?'':'color:#959595'">YTG <i class="icon iconfont icon-info"></i>
              <div v-if="SalesDataMonth==12" v-show="showInfoFlag=='YTG'&&SalesDataMonth!=month" class="info-block">{{$t('common.YTGInfo', {'year': SalesDataMonth==12?(SalesDataYear+1):SalesDataYear, 'month': $t('common.'+$commonJs.getMonthTh(SalesDataMonth+1)+'M')})}}</div>
              <div v-else v-show="showInfoFlag=='YTG'" class="info-block">{{$t('common.YTGInfo', {'year': SalesDataMonth==12?(SalesDataYear+1):SalesDataYear, 'month': $t('common.'+$commonJs.getMonthTh(SalesDataMonth+1)+'M')})}}</div>
            </td>
            <td class="f_w" :style="postData.year==year?'':'color:#959595'">{{$commonJs.numFixed(ytdTableData.YTG)}}</td>
          </tr>
          <tr v-if="legendSelt[item.title]&&postData.quartersOrMonths==2" v-for="(item, index) in chartTableData" :key="index" :style="'color:'+getColor(index)" >
            <td class="f_w">{{item.title}}</td>
            <td>{{item.value==0?'-':$commonJs.numFixed(item.value)}}</td>
          </tr>
        </table>
        <table v-else class="chartTable font12" style="width: 250px;margin-left: -20px;">
          <tr v-if="legendSelt[item.title]||index==0" :style="index==0?'background:#FDF1F4':'color:'+getColor(index-1)" class="f_w" v-for="(item, index) in chartTableData" :key="index">
            <td>{{item.title}}</td>
            <td v-for="(subItem,i) in item.value" :key="i">{{index==0?subItem:$commonJs.numFixed(subItem)}}{{item.unit}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div style="flex: 1;margin: 20px;position: relative;height:calc(100% - 42px);display: flex; flex-direction: column;">
      <div class="m_b_10">
        <button :class="sopOrShipment==1?'redButton':'cancelButtonRed'" @click="changeSopOrShipment(1)">S&OP Forecast</button>
        <button :class="sopOrShipment==2?'redButton m_l_10':'cancelButtonRed m_l_10'" @click="changeSopOrShipment(2)">S&OP Shipment</button>
      </div>
      <div style="flex: 1;border:1px solid #C73343;background-color: #fff;border-radius: 8px;">
        <div style="z-index:1;position: absolute;display: flex;justify-content: space-between;align-items: center; padding:20px 25px 20px 25px;width: calc(100% - 50px);">
          <div style="border-left: 4px solid #C73343;padding:0 10px;font-size: 16px;" class="d_flex f_w">Report
            <div v-if="sopOrShipment==2" class="d_flex m_l_20" style="font-weight: normal;">
              <span class="font12 m_r_10 m_l_20">{{$t('common.MOH')}}:</span>
              <allSelect @on-change="mohChange" :chooseData="mohSelectData" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.MOHMonthNum" :width="'160px'">
              </allSelect>
            </div>
          </div>
          <div style="font-size: 12px;font-weight: bold; text-align: right;">
            <div>{{$t('common.CurrentVersion')}}：<span style="vertical-align: baseline;" class="colorRed f_w">{{year}}{{month>9?month:('0'+month)}}</span></div>
            <div v-if="!hideBtn">{{$t('common.Status')}}：<span style="vertical-align: baseline;" class="colorRed f_w">{{brandStatus=='Closed'?$t('common.PendingOk'):$t('common.Pending')}}</span></div>
            <div v-else>&nbsp;&nbsp;</div>
          </div>
        </div>
        <div id="reportChart" style="width: 100%;height: 100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
let infoTimeOut
export default {
  name: 'report',
  data () {
    return {
      postData: {
        brandCode: '',
        year: '',
        quartersOrMonths: 1,
        MOHMonthNum: 3
      },
      brandList: [],
      mohSelectData: [
        {Code: 3, Name: this.$t('common.Future3Months')},
        {Code: 6, Name: this.$t('common.Future6Months')},
        {Code: 1, Name: this.$t('common.FutureMonthsRounding')}
      ],
      brandStatus: '',
      mktData: false,
      yearList: [],
      chartTableData: [],
      sopOrShipment: 1,
      ytdTableData: {},
      legendSelt: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      SalesDataYear: new Date().getFullYear(),
      SalesDataMonth: new Date().getMonth() + 1,
      hideBtn: false,
      showInfoFlag: false
    }
  },
  beforeCreate () {
    this.$parent.topName = 'Report'
  },
  created () {
    this.getBrandList()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
  },
  mounted () {
    document.getElementById('managRight').style.height = 'calc(100% - 60px)'
    this.$nextTick(() => {
      this.chart = echarts.init(document.getElementById('reportChart'))
      this.chart.on('legendselectchanged', obj => {
        if (this.legendSelt[obj.name]) {
          this.$set(this.legendSelt, obj.name, false)
        } else {
          this.$set(this.legendSelt, obj.name, true)
        }
      })
    })
    window.addEventListener('resize', this.resizeChart)
  },
  methods: {
    resizeChart () {
      this.chart.resize()
    },
    getBrandList () {
      this.brandList = false
      this.$axiox.get('/api/v1/admin/marketing/userModule').then(msg => {
        this.brandList = msg.data.BrandList || []
        if (this.brandList && this.brandList.length > 0) {
          this.postData.brandCode = this.brandList[0].Code
          if (this.postData.brandCode.indexOf('_') !== -1) {
            this.hideBtn = true
          } else {
            this.hideBtn = false
          }
          this.year = this.brandList[0].Year
          this.month = this.brandList[0].Month
          this.SalesDataYear = this.brandList[0].SalesDataYear
          this.SalesDataMonth = this.brandList[0].SalesDataMonth
          this.brandStatus = this.brandList[0].Status
          this.postData.year = this.year
          this.yearList = [{Code: this.year, Name: this.year}, {Code: Number(this.year) + 1, Name: Number(this.year) + 1}, {Code: Number(this.year) + 2, Name: Number(this.year) + 2}]
          this.getChartData()
        }
      })
    },
    showInfo (type) {
      if (this.showInfoFlag) {
        clearTimeout(infoTimeOut)
      }
      if (this.showInfoFlag !== type) {
        this.showInfoFlag = type
        infoTimeOut = setTimeout(() => {
          this.showInfoFlag = false
        }, 3000)
      }
    },
    getShipmentList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.version = 'SOP_Shipment'
      let url = this.$commonJs.returnQuery('/api/v1/admin/shipment', data)
      this.$axiox.get(url).then(msg => {
        this.mktData = msg.data || false
        if (this.mktData && this.mktData.ShipmentInfoModelList && this.mktData.ShipmentInfoModelList.length > 0) {
          this.mktData.ShipmentInfoModelList.forEach(item => {
            if (item.Year === this.year) {
              this.mktData.ShipmentYTD = item.ShipmentYTD
              this.mktData.ShipmentYTG = item.ShipmentYTG
            }
          })
        }
        this.getChartData()
      })
    },
    getChartData () {
      this.chart.clear()
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.sopOrShipment === 1) {
        if (data.quartersOrMonths === 1 || data.quartersOrMonths === '1') {
          data.year = this.year
        }
        let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata/mkt/report', data)
        this.$axiox.get(url).then(msg => {
          if (msg.data) {
            this.ytdTableData = msg.data.TableData || {}
          }
          if (msg.data && msg.data.ChartData) {
            let datas = {}
            let legendList = []
            let monthList = []
            let seriesList = []
            let chartTableData = []
            for (let key in msg.data.ChartData) {
              if (monthList.length === 0) {
                msg.data.ChartData[key].forEach((item, i) => {
                  monthList.push(item.YearMonth)
                })
              }
              let dataList = []
              let total = 0
              if (msg.data.ChartData[key] && msg.data.ChartData[key].length > 0) {
                msg.data.ChartData[key].forEach(val => {
                  dataList.push(val.Value)
                  total = Number(total + val.Value)
                })
              }
              if (total !== 0) {
                if (!this.legendSelt.hasOwnProperty(key)) {
                  this.$set(this.legendSelt, key, true)
                }
                legendList.push(key)
                chartTableData.push({'title': key, 'value': total})
                seriesList.push({
                  name: key,
                  data: dataList,
                  type: 'bar',
                  barMaxWidth: 10
                })
              }
            }
            this.chartTableData = chartTableData
            datas.legendList = legendList
            datas.monthList = monthList
            datas.seriesList = seriesList
            this.$nextTick(() => {
              this.getOptionData(datas)
            })
          }
        })
      } else {
        if (this.mktData && this.mktData.ShipmentInfoModelList && this.mktData.ShipmentInfoModelList.length > 0) {
          if (this.postData.quartersOrMonths === 2 || this.postData.quartersOrMonths === '2') { // 按月份
            let datas = {}
            let legendList = []
            let monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            let seriesList = []
            let chartTableData = []
            this.mktData.ShipmentInfoModelList.forEach(item => {
              if (this.postData.year === item.Year) {
                if (item.EndingInventories) {
                  let dataList = []
                  dataList.push(item.EndingInventories.Jan)
                  dataList.push(item.EndingInventories.Feb)
                  dataList.push(item.EndingInventories.Mar)
                  dataList.push(item.EndingInventories.Apr)
                  dataList.push(item.EndingInventories.May)
                  dataList.push(item.EndingInventories.Jun)
                  dataList.push(item.EndingInventories.Jul)
                  dataList.push(item.EndingInventories.Aug)
                  dataList.push(item.EndingInventories.Sep)
                  dataList.push(item.EndingInventories.Oct)
                  dataList.push(item.EndingInventories.Nov)
                  dataList.push(item.EndingInventories.Dec)
                  if (!this.legendSelt.hasOwnProperty('Ending Inventories')) {
                    this.$set(this.legendSelt, 'Ending Inventories', true)
                  }
                  legendList.push('Ending Inventories')
                  seriesList.push({
                    name: 'Ending Inventories',
                    yAxisIndex: 0,
                    barMaxWidth: 20,
                    data: dataList,
                    type: 'bar'
                  })
                  // chartTableData.push({'title': 'Ending Inventories', 'value': item.EndingInventories.AnnutalTotal || 0})
                }
                if (item.CurrentMonthShipmentPlan) {
                  let dataList = []
                  dataList.push(item.CurrentMonthShipmentPlan.Jan)
                  dataList.push(item.CurrentMonthShipmentPlan.Feb)
                  dataList.push(item.CurrentMonthShipmentPlan.Mar)
                  dataList.push(item.CurrentMonthShipmentPlan.Apr)
                  dataList.push(item.CurrentMonthShipmentPlan.May)
                  dataList.push(item.CurrentMonthShipmentPlan.Jun)
                  dataList.push(item.CurrentMonthShipmentPlan.Jul)
                  dataList.push(item.CurrentMonthShipmentPlan.Aug)
                  dataList.push(item.CurrentMonthShipmentPlan.Sep)
                  dataList.push(item.CurrentMonthShipmentPlan.Oct)
                  dataList.push(item.CurrentMonthShipmentPlan.Nov)
                  dataList.push(item.CurrentMonthShipmentPlan.Dec)
                  if (!this.legendSelt.hasOwnProperty('Shipment Plan')) {
                    this.$set(this.legendSelt, 'Shipment Plan', true)
                  }
                  legendList.push('Shipment Plan')
                  seriesList.push({
                    name: 'Shipment Plan',
                    barMaxWidth: 20,
                    yAxisIndex: 0,
                    data: dataList,
                    type: 'bar'
                  })
                  chartTableData.push({'title': 'Shipment Plan', 'value': item.CurrentMonthShipmentPlan.AnnutalTotal || 0})
                }
                if (item.MonthsOfCoverage) {
                  let dataList = []
                  dataList.push(item.MonthsOfCoverage.Jan)
                  dataList.push(item.MonthsOfCoverage.Feb)
                  dataList.push(item.MonthsOfCoverage.Mar)
                  dataList.push(item.MonthsOfCoverage.Apr)
                  dataList.push(item.MonthsOfCoverage.May)
                  dataList.push(item.MonthsOfCoverage.Jun)
                  dataList.push(item.MonthsOfCoverage.Jul)
                  dataList.push(item.MonthsOfCoverage.Aug)
                  dataList.push(item.MonthsOfCoverage.Sep)
                  dataList.push(item.MonthsOfCoverage.Oct)
                  dataList.push(item.MonthsOfCoverage.Nov)
                  dataList.push(item.MonthsOfCoverage.Dec)
                  if (!this.legendSelt.hasOwnProperty('Months Of Coverages')) {
                    this.$set(this.legendSelt, 'Months Of Coverages', true)
                  }
                  legendList.push('Months Of Coverages')
                  seriesList.push({
                    name: 'Months Of Coverages',
                    yAxisIndex: 1,
                    data: dataList,
                    type: 'line'
                  })
                  // chartTableData.push({'title': 'Months Of Coverages', 'value': item.MonthsOfCoverage.AnnutalTotal || 0})
                }
              }
            })
            this.chartTableData = chartTableData
            datas.legendList = legendList
            datas.monthList = monthList
            datas.seriesList = seriesList
            this.getShipmentOptionData(datas)
          } else if (this.postData.quartersOrMonths === 1 || this.postData.quartersOrMonths === '1') { // 按季度
            let datas = {}
            let legendList = []
            let monthList = []
            let seriesList = []
            let chartTableData = []
            let endingInventoriesList = []
            let currentMonthShipmentPlanList = []
            let monthsOfCoverageList = []
            this.mktData.ShipmentInfoModelList.forEach(item => {
              monthList.push(item.Year + '-Q1')
              monthList.push(item.Year + '-Q2')
              monthList.push(item.Year + '-Q3')
              monthList.push(item.Year + '-Q4')
              if (item.EndingInventories) {
                endingInventoriesList.push(item.EndingInventories.FirstQuarter)
                endingInventoriesList.push(item.EndingInventories.SecondQuarter)
                endingInventoriesList.push(item.EndingInventories.ThirdQuarter)
                endingInventoriesList.push(item.EndingInventories.FourthQuarter)
                if (!this.legendSelt.hasOwnProperty('Ending Inventories')) {
                  this.$set(this.legendSelt, 'Ending Inventories', true)
                }
                // chartTableData.push({'title': 'Ending Inventories', 'value': item.EndingInventories.AnnutalTotal || 0})
              }
              if (item.CurrentMonthShipmentPlan) {
                currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.FirstQuarter)
                currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.SecondQuarter)
                currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.ThirdQuarter)
                currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.FourthQuarter)
                if (!this.legendSelt.hasOwnProperty('Shipment Plan')) {
                  this.$set(this.legendSelt, 'Shipment Plan', true)
                }
                if (this.postData.year === item.Year) {
                  chartTableData.push({'title': 'Shipment Plan', 'value': item.CurrentMonthShipmentPlan.AnnutalTotal || 0})
                }
              }
              if (item.MonthsOfCoverage) {
                monthsOfCoverageList.push(item.MonthsOfCoverage.FirstQuarter)
                monthsOfCoverageList.push(item.MonthsOfCoverage.SecondQuarter)
                monthsOfCoverageList.push(item.MonthsOfCoverage.ThirdQuarter)
                monthsOfCoverageList.push(item.MonthsOfCoverage.FourthQuarter)
                if (!this.legendSelt.hasOwnProperty('Months Of Coverages')) {
                  this.$set(this.legendSelt, 'Months Of Coverages', true)
                }
                // chartTableData.push({'title': 'Months Of Coverages', 'value': item.MonthsOfCoverage.AnnutalTotal || 0})
              }
            })
            legendList.push('Ending Inventories')
            seriesList.push({
              name: 'Ending Inventories',
              yAxisIndex: 0,
              barMaxWidth: 20,
              data: endingInventoriesList,
              type: 'bar'
            })
            legendList.push('Shipment Plan')
            seriesList.push({
              name: 'Shipment Plan',
              barMaxWidth: 20,
              yAxisIndex: 0,
              data: currentMonthShipmentPlanList,
              type: 'bar'
            })
            legendList.push('Months Of Coverages')
            seriesList.push({
              name: 'Months Of Coverages',
              yAxisIndex: 1,
              data: monthsOfCoverageList,
              type: 'line'
            })
            this.chartTableData = chartTableData
            datas.legendList = legendList
            datas.monthList = monthList
            datas.seriesList = seriesList
            this.getShipmentOptionData(datas)
          } else { // 按年度
            data.version = 'SOP_Shipment'
            let url = this.$commonJs.returnQuery('/api/v1/admin/shipment/chart', data)
            this.$axiox.get(url).then(msg => {
              if (msg.data && msg.data.length > 0) {
                let datas = {}
                let legendList = []
                let monthList = []
                let seriesList = []
                let shipmentList = []
                let fcstList = []
                let fcstGrList = []
                let chartTableData = []
                msg.data.forEach((item, index) => {
                  monthList.push(item.Year + 'TTL')
                  if (item.LEData && item.LEData.length > 0) {
                    item.LEData.forEach(subItem => {
                      if (subItem.Scenario) {
                        if (!this.legendSelt.hasOwnProperty(subItem.Scenario)) {
                          this.$set(this.legendSelt, subItem.Scenario, true)
                        }
                        if (legendList.indexOf(subItem.Scenario) === -1) {
                          legendList.push(subItem.Scenario)
                          let arr = new Array(msg.data.length)
                          arr[index] = subItem.Value
                          seriesList.push({
                            name: subItem.Scenario,
                            barMaxWidth: 20,
                            yAxisIndex: 0,
                            data: arr,
                            type: 'bar'
                          })
                          chartTableData.push({'title': subItem.Scenario, 'value': arr})
                        } else {
                          seriesList.forEach(item => {
                            if (item.name === subItem.Scenario) {
                              item.data[index] = subItem.Value
                              chartTableData[legendList.indexOf(subItem.Scenario)].value[index] = subItem.Value
                            }
                          })
                        }
                      }
                    })
                  }
                  shipmentList.push(item.Shipment)
                  fcstList.push(item.Forecast)
                  fcstGrList.push(Math.round(item.ForecastGrowth * 100))
                })
                if (!this.legendSelt.hasOwnProperty('Shipment')) {
                  this.$set(this.legendSelt, 'Shipment', true)
                }
                if (!this.legendSelt.hasOwnProperty('Fcst')) {
                  this.$set(this.legendSelt, 'Fcst', true)
                }
                if (!this.legendSelt.hasOwnProperty('Fcst GR%')) {
                  this.$set(this.legendSelt, 'Fcst GR%', true)
                }
                legendList.push('Shipment')
                chartTableData.push({'title': 'Shipment', 'value': shipmentList})
                seriesList.push({
                  name: 'Shipment',
                  barMaxWidth: 20,
                  yAxisIndex: 0,
                  data: shipmentList,
                  type: 'bar'
                })
                legendList.push('Fcst')
                chartTableData.push({'title': 'Fcst', 'value': fcstList})
                seriesList.push({
                  name: 'Fcst',
                  barMaxWidth: 20,
                  yAxisIndex: 0,
                  data: fcstList,
                  type: 'bar'
                })
                legendList.push('Fcst GR%')
                chartTableData.push({'title': 'Fcst GR%', 'value': fcstGrList, 'unit': '%'})
                seriesList.push({
                  name: 'Fcst GR%',
                  yAxisIndex: 1,
                  data: fcstGrList,
                  type: 'line'
                })
                chartTableData.unshift({'title': '', 'value': monthList})
                this.chartTableData = chartTableData
                datas.legendList = legendList
                datas.monthList = monthList
                datas.seriesList = seriesList
                this.getShipmentOptionDataByYear(datas)
              }
            })
          }
        }
      }
    },
    brandChange (data) {
      this.year = data.Year
      this.month = data.Month
      this.SalesDataYear = data.SalesDataYear
      this.SalesDataMonth = data.SalesDataMonth
      this.postData.year = data.Year
      this.yearList = [{Code: this.year, Name: this.year}, {Code: Number(this.year) + 1, Name: Number(this.year) + 1}, {Code: Number(this.year) + 2, Name: Number(this.year) + 2}]
      this.brandStatus = data.Status
      if (this.postData.brandCode.indexOf('_') !== -1) {
        this.hideBtn = true
      } else {
        this.hideBtn = false
      }
      if (this.sopOrShipment === 1) {
        this.getChartData()
      } else {
        this.getShipmentList()
      }
    },
    mohChange () {
      this.getShipmentList()
    },
    changeSopOrShipment (data) {
      if (data !== this.sopOrShipment) {
        this.sopOrShipment = data
        if (data === 1) {
          if (this.postData.quartersOrMonths === 3 || this.postData.quartersOrMonths === '3') {
            this.postData.quartersOrMonths = 1
          }
          this.getChartData()
        } else {
          this.getShipmentList()
        }
      }
    },
    filterChange () {
      if (this.sopOrShipment === 1) {
        this.getChartData()
      } else {
        if (this.postData.quartersOrMonths === 3) {
          this.chartTableData = false
        }
        this.getShipmentList()
      }
    },
    yearChange () {
      if (this.postData.quartersOrMonths === 2 || this.postData.quartersOrMonths === '2') {
        this.getChartData()
      }
    },
    getOptionData (dataObj) {
      this.chart.clear()
      let optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#B62A40', '#EA6D37', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1'],
        grid: {
          top: '120',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          top: '70',
          data: dataObj.legendList,
          selected: this.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: 30
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          }
        ],
        series: dataObj.seriesList
      }
      this.chart.setOption(optionData)
      this.chart.resize()
    },
    getShipmentOptionData (dataObj) {
      this.chart.clear()
      let optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#EA6D37', '#B62A40', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1'],
        grid: {
          top: '120',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          top: '70',
          data: dataObj.legendList,
          selected: this.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          },
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            type: 'value'
          }
        ],
        series: dataObj.seriesList
      }
      this.chart.setOption(optionData)
      this.chart.resize()
    },
    getShipmentOptionDataByYear (dataObj) {
      let that = this
      that.chart.clear()
      let optionData = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let result = params[0].name + '<br>'
            params.forEach(function (item) {
              if (item.value || item.value === 0) {
                if (item.seriesName === 'Fcst GR%') {
                  result += item.marker + ' ' + item.seriesName + ' : ' + item.value + '%</br>'
                } else {
                  result += item.marker + ' ' + item.seriesName + ' : ' + that.$commonJs.numFixed(item.value) + '</br>'
                }
              } else {
                result += item.marker + ' ' + item.seriesName + ' :  - </br>'
              }
            })
            return result
          },
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#B62A40', '#EA6D37', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1', '#6B9C37'],
        grid: {
          top: '120',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          top: '70',
          data: dataObj.legendList,
          selected: that.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          },
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            type: 'value',
            axisLabel: {
              color: '#B44138',
              formatter: '{value}%'
            }
          }
        ],
        series: dataObj.seriesList
      }
      that.chart.setOption(optionData)
      that.chart.resize()
    },
    getColor (index) {
      switch (index) {
        case 0:
          return '#B62A40'
        case 1:
          return '#EA6D37'
        case 2:
          return '#BF9C37'
        case 3:
          return '#6B853E'
        case 4:
          return '#54BBC3'
        case 5:
          return '#398AC4'
        case 6:
          return '#B62FB1'
        case 7:
          return '#6B9C37'
        default:
          return '#666'
      }
    }
  }
}
</script>

<style scoped>
  label{
    display: block;
    line-height: 20px;
    margin-left: 10px;
    font-size: 13px;
  }
  .radio_type{
    margin-top: -4px;
    width: 12px;
    height:12px;
    appearance: none;
    position: relative;
    margin-right: 10px;
    border: none;
  }
  .radio_type:before{
    content: '';
    width: 12px;
    height: 12px;
    border: 1px solid #C73343;
    display: inline-block;
    border-radius: 50%;
  }
  .radio_type:checked:before{
    content: '';
    width: 12px;
    height: 12px;
    border: 1px solid #C73343;
    display: inline-block;
    border-radius: 50%;
  }
  .radio_type:checked:after{
    content: '';
    width: 8px;
    height: 8px;
    text-align: center;
    background:#C73343;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .radio_type:checked+label{
    /*color: #EDD19D;*/
  }
  .radio_type:disabled:before{
    background: #F5F5F5;
    border: 1px solid #ccc;
  }
  .chartTable{
    width: 90%;
    text-align: center;
    line-height: 30px;
    border-collapse: collapse;
    background: #F7F7F7;
    margin-top: 15px;
  }
  .chartTable td{
    border: 1px solid #E2E2E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/report.vue